import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Stack, Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import useCurrentDateTime from 'src/hooks/use-current-date-time';
import { TopupTxType } from 'src/type/topup-deposit';
import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';

const Schema = Yup.object().shape({
  reason: Yup.string(),
});

const defaultValues = {
  reason: '',
};

type Props = {
  open: boolean;
  isCreateAndApprove?: boolean;
  onClose: VoidFunction;
  tx: TopupTxType;
  handleReload: VoidFunction;
};

export default function TopupApproveDialog({
  open,
  isCreateAndApprove,
  onClose,
  tx,
  handleReload,
}: Props) {
  const currentDateTime = useCurrentDateTime();

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (values) => {
    try {
      await axios.post(endpoints.transactions.topupDeposit.approve(tx.id), {
        note: values.reason,
        currentDateTime,
      });
      if (!isCreateAndApprove) {
        handleReload();
      }
      beforeClose();
      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
    } catch (error) {
      toastError(error);
    }
  });

  const beforeClose = () => {
    if (isCreateAndApprove) {
      handleReload();
    }
    reset(defaultValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={beforeClose} maxWidth="sm" fullWidth>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>อนุมัติรายการเติมวงเงินหลักประกัน</DialogTitle>

        <DialogContent>
          <Stack spacing={3}>
            <RHFTextField
              multiline
              rows={3}
              name="reason"
              placeholder="หมายเหตุ"
              InputLabelProps={{ shrink: true }}
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={beforeClose} disabled={isSubmitting}>
            ยกเลิก
          </Button>
          <LoadingButton variant="contained" type="submit" loading={isSubmitting}>
            ดำเนินการต่อ
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
